export default "__VITE_ASSET__CXfYJD2X__"